import { message } from 'antd'

export type StoSearchField = 'token' | 'stoId' | 'clientId'

// Handoff payloads can carry a full card token, so an orphaned key is a real exposure: it survives
// logout and is readable by anything on this origin. The destination tab deletes its own key; this
// TTL collects the ones whose tab never ran (blocked popup, tab closed before load).
export const STO_SEARCH_HANDOFF_PREFIX = 'sto-search-token-'
export const STO_SEARCH_HANDOFF_TTL_MS = 5 * 60 * 1000

// Collect handoff keys whose destination tab never consumed them. Only our own prefix is
// touched — this origin's storage is shared with other features.
export const pruneStoSearchHandoffs = () => {
    try {
        const handoffKeys: string[] = []
        // Snapshot first: removing inside a live localStorage.key(i) walk reindexes and skips entries.
        for (let i = 0; i < localStorage.length; i++) {
            const storedKey = localStorage.key(i)
            if (storedKey && storedKey.indexOf(STO_SEARCH_HANDOFF_PREFIX) === 0) handoffKeys.push(storedKey)
        }

        const now = Date.now()
        handoffKeys.forEach(storedKey => {
            // Key shape: `${prefix}${Date.now()}-${base36}`. The random part is base-36 digits
            // only, so it never contains '-' and the split is unambiguous.
            const timestamp = Number(storedKey.slice(STO_SEARCH_HANDOFF_PREFIX.length).split('-')[0])
            // A malformed key of ours is dead weight either way — drop it.
            if (!isFinite(timestamp) || now - timestamp > STO_SEARCH_HANDOFF_TTL_MS) {
                localStorage.removeItem(storedKey)
            }
        })
    } catch (error) {
        // storage unavailable (private mode / disabled) — a failed sweep must never block a search
    }
}

export const openStoSearch = (field: StoSearchField, value: string | number | null) => {
    if (value === null || value === undefined || value === '') return
    pruneStoSearchHandoffs()
    const key = `${STO_SEARCH_HANDOFF_PREFIX}${Date.now()}-${Math.random()
        .toString(36)
        .slice(2)}`

    try {
        localStorage.setItem(key, JSON.stringify({ field, value: String(value) }))
    } catch (error) {
        message.error('לא ניתן לפתוח חיפוש')
        return
    }

    // A blocked popup returns null/undefined — the tab that would delete the key never runs,
    // so drop it here rather than leaving the token for the TTL sweep.
    const handoffWindow = window.open(`/sto-search?handoff=${encodeURIComponent(key)}`, '_blank')
    if (!handoffWindow) {
        try {
            localStorage.removeItem(key)
        } catch (error) {
            // couldn't remove it now; the TTL sweep collects it
        }
        message.error('לא ניתן לפתוח חלון חדש — יש לאפשר חלונות קופצים')
    }
}
